type Notice = {
  message: string;
};

// return false if you don't want the error to be reported
export const filterHoneybadgerNotices = (notice: Notice | undefined): boolean => {
  if (!notice) return true;

  return (
    !notice?.message?.includes('Failed to load https://www.googletagmanager.com/gtag/js') &&
    !notice?.message?.includes('Promise.withResolvers is not a function')
  );
};
